import { PadiModal } from '../helpers'

export default function InsurancePopup({ isVisible, onClose }) {
  return (
    <PadiModal isOpen={isVisible} onClose={onClose} className='virtual-tour'>
      <iframe
        src='https://world.dan.org/membership-coverage/padi-global-short-term/'
        className='dan-iframe'
      />
    </PadiModal>
  )
}
